import { Card } from "antd";
import styled, { css } from "styled-components";

type Status = "archived" | "hasRoutes";

export const StyledImgWrapper = styled.div`
    display: block;
    overflow: hidden;
    width: 40px;
    height: 40px;
    border-radius: 4px;
`;

export const StyledCard = styled(Card)<{ $status?: Status }>`
    position: relative;
    z-index: 1;

    background: color-mix(
        in srgb,
        ${({ theme }) => theme.itemBackground} 10%,
        transparent
    );

    .ant-card-body {
        padding: 12px 18px;
    }

    ${({ $status, theme }) =>
        $status &&
        css`
            &::after {
                content: "";
                position: absolute;
                inset: 0;
                pointer-events: none;
                z-index: 0;
                border-radius: 8px;

                ${$status === "archived" &&
                css`
                    background: ${theme.secondaryBackgroundColor};
                `}

                ${$status === "hasRoutes" &&
                css`
                    background: color-mix(
                        in srgb,
                        ${theme.dangerTypographyColor} 7%,
                        transparent
                    );
                `}
            }
        `}
`;

export const StyledCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    z-index: 1;
`;

export const StyledChainIndicator = styled.div`
    position: absolute;
    z-index: 3;
    left: 50%;
    top: -16px;

    transform: translateX(-50%);

    svg {
        font-size: 18px;
        transform: rotate(-45deg);
    }
`;
